import { AccessLevel } from "../../../pojo/Fls";
import { MultiselectModelI } from "../../s25-multiselect/s25.multiselect.component";

export namespace RoleRights {
    /**
     * A right definition from the backend enum
     */
    export interface RightDefinition {
        rightName: string;
        displayName: string;
        category: string;
        description: string;
        readDescription: string;
    }

    /**
     * A contact role
     */
    export interface ContactRole {
        contRoleId: number;
        roleName: string;
        defnState: number;
        sortOrder: number;
    }

    /**
     * A role-right assignment
     */
    export interface RoleRightAssignment {
        contRoleId: number;
        rightName: string;
        accessLevel: AccessLevel;
    }

    /**
     * View model for displaying a right with its role assignments
     */
    export interface RightWithRoles {
        right: RightDefinition;
        roleAssignments: Map<number, AccessLevel>; // roleId -> accessLevel
        roles?: MultiselectModelI;
        editRoles?: MultiselectModelI;
    }

    /**
     * Grouped rights by category for display
     */
    export interface RightsByCategory {
        category: string;
        rights: RightWithRoles[];
    }

    /**
     * Response from /definitions endpoint
     */
    export interface DefinitionsResponse {
        definitions: RightDefinition[];
        count: number;
    }

    /**
     * Response from /roles endpoint
     */
    export interface RolesResponse {
        roles: ContactRole[];
        count: number;
    }

    /**
     * Response from /all endpoint
     */
    export interface AllRoleRightsResponse {
        roleRights: Record<number, RoleRightAssignment[]>;
        roleCount: number;
    }

    /**
     * Combined configuration with right definition and assigned roles
     * Returned from /config endpoint
     */
    export interface RightWithRolesConfig {
        rightName: string;
        displayName: string;
        category: string;
        description: string;
        readDescription?: string; //holds a description for read-only permissions
        roles: RoleWithAccessLevel[];
    }

    /**
     * Role with its access level for a specific right
     */
    export interface RoleWithAccessLevel {
        roleId: number;
        roleName: string;
        accessLevel: AccessLevel;
    }

    export enum RoleRightsList {
        SE_BUDGET = "SE_BUDGET",
        SE_ORG_EDIT = "SE_ORG_EDIT",
        SE_ORG_CONTACTS = "SE_ORG_CONTACTS",
        SE_FORMS_MANAGE = "SE_FORMS_MANAGE",
    }
}
